import { Card } from "../../../../../../shared/card/card.tsx";
import { EmptyStateMessage } from "../../../../../../shared/empty-state-message/empty-state-message.tsx";
import styles from "./time-breakdown-cards.module.css";
import { TimeBreakdown } from "../../../types.ts";
import clsx from "clsx";

interface TimeBreakdownCardsProps {
  breakdowns: TimeBreakdown[];
}

function isMiscellaneousCategory(title: string | undefined | null): boolean {
  const t = title?.toLowerCase().trim() ?? "";
  return t === "miscellaneous";
}

export const TimeBreakdownCards = ({ breakdowns }: TimeBreakdownCardsProps) => {
  const visibleBreakdowns = breakdowns.filter(
    (item) => !isMiscellaneousCategory(item.title),
  );

  return (
    <Card className={styles.container} padding="5xl">
      <div className={styles.headerSection}>
        <h3 className="heading-sm">Time Breakdown by Category</h3>
        <p className="sub-heading-sm">
          Total hours spent across all categories
        </p>
      </div>

      <div className={styles.gridContainer}>
        {visibleBreakdowns.map((item) => {
          const formatCategory = (val: string) => {
            if (!val) return "";
            const lower = val.toLowerCase().trim();
            if (lower === "others") return "Miscellaneous";
            if (lower === "r & d" || lower === "r&d" || lower === "r - and - d" || lower === "r-and-d") return "R & D";
            return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
          };

          const formatTimeString = (timeStr: string | undefined | null) => {
            if (!timeStr) return "0";
            const [h, m] = timeStr.split(":").map(Number);
            const total = h + m / 60;
            return Number(total.toFixed(1)).toString();
          };

          const formatValue = (val: number | undefined | null) =>
            val !== undefined && val !== null
              ? Number(val.toFixed(1)).toString()
              : "0";

          return (
            <Card
              key={item.title}
              variant="default"
              className={styles.breakdownCard}
              padding="3xl"
            >
              <div className={styles.cardHeader}>
                <span className="heading-xs text-capitalize">
                  {formatCategory(item.title)}
                </span>
                <span
                  className={clsx(
                    styles.percentageBadge,
                    "sub-heading-xs font-700",
                  )}
                >
                  {formatValue(item.percentage)}%
                </span>
              </div>
              <div className="heading-xl color-accent font-700">
                {formatTimeString(item.time)}
                <span className="heading-xl color-accent font-700">h</span>
              </div>
            </Card>
          );
        })}
        {visibleBreakdowns.length === 0 && (
          <EmptyStateMessage className={styles.emptyState} />
        )}
      </div>
    </Card>
  );
};
